import styled from "styled-components";

export const FollowUpCall = styled.div`
  width: 100%;
  .call {
    display: flex;
    .patient-image {
      border: 15px solid #eaf6ff;
      border-radius: 50%;
      margin-right: 20px;
      width: fit-content;
      height: fit-content;
      position: relative;
      &--denied {
        border: 15px solid #ff575733;
      }
      &__denied {
        position: absolute;
        bottom: -5px;
        right: -5px;
        background-color: #ff5757;
        width: 42px;
        height: 42px;
        border-radius: 9.83px;
        border: 1.4px solid var(--base-White-I, #ffffff);
        font-size: 15px;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    &__info {
      display: flex;
      flex-direction: column;
      width: 100%;
      justify-content: space-between;
    }
    &__container {
      display: flex;
      justify-content: space-between;
    }
    &__left {
      display: flex;
      flex-direction: column;
    }
    &__name {
      color: #1f1f52;
      font-size: 19.73px;
      margin-bottom: 5px;
      font-family: Nunito Sans;
    }
    &__number {
      color: #1f1f52;
      font-family: Nunito Sans;
      font-size: 17px;
      margin-bottom: 5px;
    }
    &__program {
      border-radius: 5px;
      padding: 2px 4px;
      background-color: #efeff9;
      font-size: 12px;
      width: fit-content;
    }
    &__calling {
      align-items: center;
      font-size: 20px;
      color: #707582;
      font-family: Nunito Sans;
      display: flex;
    }
    &__duration {
      font-size: 17px;
      margin-top: 5px;
      color: #707582;
    }
    &__buttons {
      display: flex;
      align-items: center;
    }
    &__button {
      width: 61px;
      height: 61px;
      border-radius: 14px;
      background-color: #f4f6f9;
      color: #3e3e5b;
      margin-left: 20px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 26px;
      &--muted {
        background-color: #707582;
        color: #ffffff;
      }
      &--red {
        background-color: #ff5757;
        color: #ffffff;
      }
    }
    .buttons-denied {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin: auto;
    }
    &__right {
      width: 100%;
      display: flex;
      flex-direction: column;
    }
    .button-denied {
      margin: 10px 0px;
      width: 356px;
    }
    .button-separator {
      height: 29px;
      border-left: 1px solid var(--Backgrounds-Separador-I, #cfd3dd);
      margin-left: 20px;
    }
  }
  .summary {
    background-color: #f7f7f8;
    padding: 18px 18px 0px 18px;
    border-radius: 12.44px;
    margin-top: 20px;
    height: fit-content;
    height: 131px;
    overflow: auto;
    &__title {
      font-size: 17px;
      color: #1f1f52;
      font-family: Nunito Sans Bold;
      margin-bottom: 7px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .copy-btn {
        background: none;
        border: none;
        color: #6c6bcc;
        cursor: pointer;
        font-size: 14px;
        display: flex;
        align-items: center;
        gap: 5px;
        font-weight: 600;
        font-family: Nunito Sans;

        &:hover {
          text-decoration: underline;
        }
      }
    }
    &__text {
      color: #3e3e5b;
      padding-bottom: 18px;
      .label-message {
        font-family: Nunito Sans Bold;
        font-size: 13px;
      }
      .message {
        font-family: Nunito Sans;
        font-size: 13px;
      }
    }
  }
  .call-ended {
    &__top {
      display: flex;
      justify-content: space-between;
    }
    &__bottom {
      display: flex;
      flex-direction: column;
    }
    &__buttons {
      display: flex;
      justify-content: space-between;
      &__left {
        display: flex;
      }
    }
    &__button {
      &--right {
        margin-left: 10px;
      }
      &--left {
        margin-right: 10px;
      }
    }
    &__left {
      display: flex;
    }
    .patient-image {
      border: 5px solid #eaf6ff;
      border-radius: 50%;
    }
    .patient-info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 7.5px;
      color: #1f1f52;
      font-size: 17px;
      &__name {
        font-family: Nunito Sans Bold;
      }
    }
    &__status {
      color: #707582;
    }
    &__transcription {
      height: 200px;
      padding: 10px 10px 0px 10px;
      border-radius: 14px;
      background-color: #f7f7fd;
      font-size: 15px;
      color: #1f1f52;
      margin: 20px 0 10px;
    }
  }
`;

export const CallSettings = styled.div`
  background-color: #ffffff;
  border-radius: 20px;
  box-shadow: 0px 3px 10px 3px #1c1f5833;
  width: 626px;
  .header {
    padding: 22.35px 13px;
    border-bottom: 1px solid var(--Backgrounds-Separador-I, #cfd3dd);
    display: flex;
    align-items: center;
    color: #707582;
    &__icon {
      font-size: 11px;
      align-items: center;
      margin-right: 13px;
    }
    &__text {
      font-size: 17px;
    }
  }
  .selects {
    display: flex;
    flex-direction: column;
    padding: 25px 20px;
    .select {
      margin-bottom: 20px;
    }
  }
`;
